import { useEffect } from 'react';
import api from '../services/api';

export function VisitorTracker() {
  useEffect(() => {
    // Only track if not in admin pages or development (per user's choice)
    const isLocalhost = window.location.hostname === 'localhost';
    const isAdmin = window.location.pathname.startsWith('/astadmin');
    
    // Check session storage to avoid double counting in same session
    const hasBeenTracked = sessionStorage.getItem('ast_visitor_tracked');
    
    if (!isAdmin && !hasBeenTracked) {
      const registerVisit = async () => {
        try {
          await api.post('visit/');
          sessionStorage.setItem('ast_visitor_tracked', 'true');
        } catch (error) {
          console.error('Failed to register visit', error);
        }
      };
      registerVisit();
    }
  }, []);

  return null;
}
